'use client';

import { useContext, useEffect } from 'react';
import { AppContext } from '@/context/AppContext';
import { motion } from 'framer-motion';
import { AboutIntro } from "@/components/about/AboutIntro";
import { SkillShowcase } from "@/components/about/SkillShowcase";
import { ActivityShowcase } from "@/components/about/ActivityShowcase";
import { CareerTimeline } from "@/components/about/CareerTimeline";
import { AboutData } from "@/data/types"; // Importiere den Typ aus deinen Typdefinitionen
import { useData } from "@/i18n/LangContext";

// Verwende den Typ für deine Props
export function AboutPageClient({
                                  title,
                                  intro,
                                  buttons,
                                  skillsTitle,
                                  skillCategories,
                                  activityTitle,
                                  activityNote,
                                  activityItems,
                                  careerTitle,
                                  careerTimeline
                                }: AboutData) {
  const { ui } = useData();
  const { setActivePage } = useContext(AppContext);

  useEffect(() => {
    setActivePage("about");
  }, [setActivePage]);

  // Animationsvarianten ähnlich wie auf der Home-Seite
  const pageVariants = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: {
        duration: 0.5,
        when: "beforeChildren",
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  return (
    <motion.div
      className="w-full max-w-6xl py-4 md:py-16 transition-all duration-400"
      initial="initial"
      animate="animate"
      variants={pageVariants}
    >
      {/* Rest des Codes bleibt gleich */}
      <motion.div
        className="inline-block bg-[#0C2019]/40 backdrop-blur-sm border border-[#88ff88]/20 px-3 py-1 rounded-lg mb-6"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
      >
        <span className="text-[#88ff88] text-sm">{ui.about.badge}</span>
      </motion.div>

      <motion.h1
        className="text-4xl md:text-5xl font-bold mb-6 text-[#88ff88]"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        {title}
      </motion.h1>

      <AboutIntro
        intro={intro}
        buttons={buttons}
      />

      <SkillShowcase
        title={skillsTitle}
        categories={skillCategories}
      />

      <ActivityShowcase
        title={activityTitle}
        note={activityNote}
        items={activityItems}
      />

      <CareerTimeline
        title={careerTitle}
        timeline={careerTimeline}
      />
    </motion.div>
  );
}